
// 新增 模板
export const addTmp = {
  customerId: '', // 客户id
  claimsNode: '', // 理赔节点1:转运 2:揽收 3:派送
  declaredValue: '', // 申报价值阈值（<=）
  defaultReviewer: '', // 默认审核人id
  defaultReviewerName: '' // 默认审核人
};
